import { all, takeLatest } from "redux-saga/effects";

import { addPermissionAssignmentSaga } from "./sagas/add-permission-assignment.saga";
import { addPublicPermissionAssignmentSaga } from "./sagas/add-public-permission-assignment.saga";
import { unpublishCampaignSaga } from "./sagas/unpublish.saga";
import { actionTypes } from "./actions";

export function* campaignsWatchSaga() {
	yield all([
		takeLatest(
			actionTypes.ADD_PUBLIC_PERMISSION_ASSIGNMENT,
			addPublicPermissionAssignmentSaga,
		),
		takeLatest(
			actionTypes.ADD_PERMISSION_ASSIGNMENT,
			addPermissionAssignmentSaga,
		),
		takeLatest(actionTypes.UNPUBLISH_CAMPAIGN, unpublishCampaignSaga),
	]);
}
